import { ComponentProps } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import MapAwareToast from '@alltrails/maps/components/MapAwareToast/MapAwareToast';
import { useGetHeatmapOptionsDataQuery } from '../../redux/heatmapsApi';
import { useAppSelector } from '../../redux/helpers';

type Props = {
  horizontalMapPadding?: ComponentProps<typeof MapAwareToast>['horizontalMapPadding'];
};

const HeatmapErrorToast = ({ horizontalMapPadding }: Props) => {
  const intl = useIntl();
  const dynamicStyleIds = useAppSelector(state => state.map.dynamicStyleIds);

  const { isError, refetch } = useGetHeatmapOptionsDataQuery(undefined, {
    skip: !dynamicStyleIds.includes('newHeatmap')
  });

  return (
    <MapAwareToast
      horizontalMapPadding={horizontalMapPadding}
      isOpen={isError}
      message={<FormattedMessage defaultMessage="Unable to load heatmap options" />}
      type="neutral"
      testId="heatmap-error-toast"
      actionText={intl.formatMessage({ defaultMessage: 'Retry' })}
      action={refetch}
    />
  );
};

export default HeatmapErrorToast;
